import {Action, Catalog} from '../../../../common/types/common';
import {BankAccountFile, BankAccountFileType, BankAccountState} from '../../types/mx/types';
import {BankAccountFormType} from '../../types/mx/containers';
import {BankTarget} from '../../../loan/common/types/types';

export const GROUP_BANK_ACCOUNT_SAVE_ACTION: Action = {
    name: 'GROUP_BANK_ACCOUNT_SAVE_ACTION',
    action: (groupId: string = null, formType: BankAccountFormType = BankAccountFormType.CREATE_FORM_FROM_LOAN, target: string = BankTarget.MOTORFY) => ({
        groupId,
        formType,
        target,
        type: GROUP_BANK_ACCOUNT_SAVE_ACTION.name
    })
};

export const GROUP_BANK_ACCOUNT_SAVE_SUCCESS_ACTION: Action = {
    name: 'GROUP_BANK_ACCOUNT_SAVE_SUCCESS_ACTION',
    action: (bankAccountForm: BankAccountState, formType: BankAccountFormType, target: string) => ({
        bankAccountForm,
        formType,
        target,
        type: GROUP_BANK_ACCOUNT_SAVE_SUCCESS_ACTION.name
    })
};

export const GROUP_CHANGE_BANK_ACTION: Action = {
    name: 'GROUP_CHANGE_BANK_ACTION',
    action: (bankSelected: Catalog, error: string = null) => ({
        bankSelected, error,
        type: GROUP_CHANGE_BANK_ACTION.name
    })
};

export const GROUP_CHANGE_BANK_ACCOUNT_NUMBER_ACTION: Action = {
    name: 'GROUP_CHANGE_BANK_ACCOUNT_NUMBER_ACTION',
    action: (accountNumber: string, error: string = null) => ({
        accountNumber, error,
        type: GROUP_CHANGE_BANK_ACCOUNT_NUMBER_ACTION.name
    })
};

export const GROUP_CHANGE_BENEFICIARY_ACTION: Action = {
    name: 'GROUP_CHANGE_BENEFICIARY_ACTION',
    action: (beneficiary: string, error: string = null) => ({
        beneficiary, error,
        type: GROUP_CHANGE_BENEFICIARY_ACTION.name
    })
};

export const GROUP_CHANGE_CLABE_ACTION: Action = {
    name: 'GROUP_CHANGE_CLABE_ACTION',
    action: (clabe: string, error: string = null) => ({
        clabe, error,
        type: GROUP_CHANGE_CLABE_ACTION.name
    })
};

export const GROUP_DROP_FILE_IDENTIFICATION_ACTION: Action = {
    name: 'GROUP_DROP_FILE_IDENTIFICATION_ACTION',
    action: (file: BankAccountFile, error: string = null) => ({
        file, error,
        type: GROUP_DROP_FILE_IDENTIFICATION_ACTION.name
    })
};

export const GROUP_DROP_FILE_ACCOUNT_ACTION: Action = {
    name: 'GROUP_DROP_FILE_ACCOUNT_ACTION',
    action: (file: BankAccountFile, error: string = null) => ({
        file, error,
        type: GROUP_DROP_FILE_ACCOUNT_ACTION.name
    })
};

export const GROUP_DELETE_FILE_REQUEST_ACTION: Action = {
    name: 'GROUP_DELETE_FILE_REQUEST_ACTION',
    action: (file: BankAccountFile, error: string = null) => ({
        file, error,
        type: GROUP_DELETE_FILE_REQUEST_ACTION.name
    })
};

export const GROUP_DELETE_FILE_SUCCESS_ACTION: Action = {
    name: 'GROUP_DELETE_FILE_SUCCESS_ACTION',
    action: (fileId: string, fileType: BankAccountFileType, error: string = null) => ({
        fileId, fileType, error,
        type: GROUP_DELETE_FILE_SUCCESS_ACTION.name
    })
};
